import React from "react";
import { Button, Form } from "semantic-ui-react";
import { useWindowWidth } from "@common/components/helpers/useWindowWidth";
import useLogin from "@common/components/hooks/useLogin";

export default function ToggleButtons({
  value,
  onToggle = (value) => {},
  label = "",
  fieldStyle = "flex-between flex-row-center my-1",
  labelStyle = "p-0",
  buttonsContainerStyle = "flex-row",
}) {
  const width = useWindowWidth();
  const [{ isInReadMode }] = useLogin();
  return (
    <>
      <Form.Field className={fieldStyle}>
        <label className={`${width > 700 ? "w-60" : "w-40"} ${labelStyle}`}>
          {label}
        </label>
        <div className={buttonsContainerStyle}>
          <Button
            onClick={() => onToggle(true)}
            type="button"
            positive={value === true}
            disabled={isInReadMode}
          >
            Yes
          </Button>
          <Button
            onClick={() => onToggle(false)}
            type="button"
            positive={value === false}
            disabled={isInReadMode}
          >
            No
          </Button>
        </div>
      </Form.Field>
    </>
  );
}
